import { useEffect } from 'react';

export function useJsonLd(data: object | object[] | null | undefined) {
  const serialized = data ? JSON.stringify(data) : '';

  useEffect(() => {
    const scriptId = 'route-jsonld';
    const existing = document.getElementById(scriptId) as HTMLScriptElement | null;

    if (!serialized) {
      existing?.remove();
      return;
    }

    if (existing) {
      existing.textContent = serialized;
    } else {
      const script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      script.textContent = serialized;
      document.head.appendChild(script);
    }
  }, [serialized]);
}